import React from "react";
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { IconInstagram, IconLinkedIn, IconTwitter, IconYoutube } from "./icons";
import brandLogo from "./assets/d_logo-removebg-preview.png";

const Footer = () => {
  return (
    <footer className="landing-footer">
      <div className="section-container landing-footer-shell">
        <div className="landing-footer-main">
          <div className="landing-footer-brand">
            <img
              src={brandLogo}
              alt="Douglas & McCartney"
              className="landing-footer-logo"
              loading="lazy"
              decoding="async"
            />
            <p className="landing-footer-tagline">
              A structured real estate advisory platform.
            </p>
          </div>

          <nav className="landing-footer-pages" aria-label="Footer pages">
            <p className="landing-footer-title">Pages</p>
            <ul className="landing-footer-links">
              <li><Link to="/" className="landing-footer-link">Home</Link></li>
              <li><Link to="/about" className="landing-footer-link">About</Link></li>
              <li><Link to="/divisions" className="landing-footer-link">Divisions</Link></li>
              <li><Link to="/why-partner" className="landing-footer-link">Why Partner</Link></li>
              <li><Link to="/partnership-model" className="landing-footer-link">Partnership Model</Link></li>
              <li><Link to="/leadership" className="landing-footer-link">Leadership</Link></li>
              <li><Link to="/insights" className="landing-footer-link">Insights</Link></li>
              <li><Link to="/contact" className="landing-footer-link">Contact</Link></li>
            </ul>
          </nav>

          <div className="landing-footer-connect">
            <p className="landing-footer-title">Connect</p>
            <a
              href="tel:+919535298949"
              className="landing-footer-phone"
            >
              +91 95352 98949
            </a>
            <a
              href="mailto:partnerships@douglasmccartney.com"
              className="landing-footer-phone"
            >
              partnerships@douglasmccartney.com
            </a>
            {/* Social icons hidden for now */}
            {/*
            <div className="landing-footer-social">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="landing-footer-social-link"
              >
                <IconLinkedIn className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="landing-footer-social-link"
              >
                <IconInstagram className="h-4 w-4" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter"
                className="landing-footer-social-link"
              >
                <IconTwitter className="h-4 w-4" />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
                className="landing-footer-social-link"
              >
                <IconYoutube className="h-4 w-4" />
              </a>
            </div>
            */}
          </div>
        </div>

        <div className="landing-footer-bottom">
          <div className="landing-footer-legal">
            <Link to={ROUTES.TERMS} target="_blank" rel="noopener noreferrer" className="landing-footer-legal-link">Terms & Conditions</Link>
            <Link to={ROUTES.PRIVACY} target="_blank" rel="noopener noreferrer" className="landing-footer-legal-link">Privacy Policy</Link>
            <Link to={ROUTES.CANCELLATION_REFUND} target="_blank" rel="noopener noreferrer" className="landing-footer-legal-link">Cancellation & Refund</Link>
            <Link to="/contact" className="landing-footer-legal-link">Contact Us</Link>
            <Link to="/about" className="landing-footer-legal-link">About Douglas & McCartney</Link>
          </div>
          <span className="landing-footer-copy">Copyright 2026 Douglas & McCartney</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
